export default "__VITE_ASSET__DPVt4ETG__"